var map = {
	"./audio-lg.png": 779,
	"./audio.png": 780,
	"./compressed-lg.png": 781,
	"./compressed.png": 782,
	"./doc-lg.png": 783,
	"./doc.png": 784,
	"./excel-lg.png": 785,
	"./excel.png": 786,
	"./files icon-DOCX.png": 787,
	"./files icon-PDF.png": 788,
	"./files icon-PPT.png": 789,
	"./files icon-XLS.png": 790,
	"./files icon-folder.png": 791,
	"./files icon-folder@2x.png": 792,
	"./files icon-folder@3x.png": 793,
	"./files icon-music.png": 794,
	"./files icon-other.png": 795,
	"./files icon-picture.png": 796,
	"./files icon-video.png": 797,
	"./files icon-zip.png": 798,
	"./folderIcon.png": 799,
	"./image-lg.png": 800,
	"./image.png": 801,
	"./pdf-lg.png": 802,
	"./pdf.png": 803,
	"./powerpoint-lg.png": 804,
	"./powerpoint.png": 805,
	"./trash.png": 406,
	"./unknown-lg.png": 806,
	"./unknown.png": 807,
	"./video-lg.png": 808,
	"./video.png": 809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;